<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="false"
      :filename="`Receipt-${order.number}`"
      :pdf-quality="2"
      :manual-pagination="true"
      :paginate-elements-by-height="1400"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2Pdf"
    >
      <!--
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
       -->

      <section slot="pdf-content">
        <!-- PDF Content Here -->
        <section class="pdf-item">
          <!-- Header START-->
          <div class="main-wrapper">
            <div class="header">
              <div class="logo">
                <logo class="logo cursor-pointer"/>
              </div>
              <div class="heading">Order Invoice</div>
            </div>
            <!-- Header END-->
            <!-- Section START-->
            <div class="receipt-section column">
              <div class="section-column">
                <div class="section-head">
                  <span>From:</span>
                  <span>Authorize Local</span>
                </div>
                <div class="section-cont">267 Fifth Ave, New York, NY 10016</div>
              </div>
              <div class="section-column">
                <div class="section-head text-right">
                  <span>Date</span>
                  <span>{{ getRegularDate(order.created) }}</span>
                </div>
              </div>
            </div>
            <!-- Section END-->
            <!-- Section START-->
            <div class="receipt-section column">
              <div class="section-column">
                <div class="section-head">
                  <span>Billed To</span>
                  <span>{{ order.customer_name }}</span></div>
                <div class="section-cont">
                  {{ order.billing_address.street }}, {{ order.billing_address.unit }} {{ order.billing_address.zipcode }}, {{ order.billing_address.state }}<br>
                  {{ activeUserInfo.phone }}
                </div>
              </div>
              <div class="section-column">
                <div class="section-head">
                  <span>Order Number #:</span>
                  <span>{{ order.number }}</span></div>
              </div>
              <div class="section-column">
                <div class="section-head">
                  <span>Payment Method:</span>
                </div>
                <span> {{order.charge.payment_method_details.card.brand}} ending in <span>{{ order.charge.payment_method_details.card.last4 }}</span> (Expires {{ order.charge.payment_method_details.card.exp_month }}/{{ order.charge.payment_method_details.card.exp_year }})</span>
              </div>
            </div>
            <!-- Section END-->
            <!-- Section START-->
            <div class="receipt-section">
              <div class="section-head"><span>Your Order:</span></div>
              <div class="order-items" v-if="order.lines">
                <div class="item"  v-for="(item, index) in order.lines.data" :key="index">
                  <div class="item-name">{{item.description}}</div>
                  <div class="item-price">${{ formatPrice(item.amount / 100) }}</div>
                </div>

              </div>
            </div>
            <!-- Section END-->
            <!-- Section START-->
            <div class="receipt-section subtotal">
              <div class="total">
                <div class="item">
                  <div class="item-name">Items Subtotal:</div>
                  <div class="item-price">${{ formatPrice(order.lines.data.reduce((a, b) => { return a + b['amount'] }, 0) / 100) }}</div>
                </div>
                <div class="item">
                  <div class="item-name">Sales Tax</div>
                  <div class="item-price">$ 0.00</div>
                </div>
                <div class="grand-total">
                  <div class="item-name">TOTAL:</div>
                  <div class="item-price">${{ formatPrice(order.total / 100)}}</div>
                </div>

              </div>
            </div>
            <!-- Section END-->
            <div class="brand">© AUTHORIZE LOCAL LLC.<br>267 Fifth Ave, New York, NY 10016</div>
          </div>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import Logo from '../Logo'

export default {
  props: {
    order: {
      type: Object
    },
    showDetail: {
      type: Boolean
    },
    print: {
      type: Boolean
    }
  },
  name: 'printPdfTemplate',
  components: {
    VueHtml2pdf,
    Logo
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  mounted () {
    console.log('print order', this.order)
    this.generateReport()
  },
  watch: {
    print () {
      if (this.print) {
        console.log('watchin print', this.print)
        this.generateReport()
      }
    },
    showDetail () {
      if (!this.showDetail) {
        this.close()
      }
    }
  },
  methods: {
    getRegularDate (unix_timestamp) {
      return new Date(unix_timestamp * 1000).toDateString()
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    calculatePrice (priceitem) {
      const item = JSON.parse(JSON.stringify(priceitem))
      console.log('item', item)
      if (item.size) {
        item.price = item.size.selected_value.price
      }
      if (item.modifier.length > 0) {
        item.modifier.forEach(function (key) {

          if (typeof key.modifier.selected_value !== 'undefined') {
            if (Array.isArray(key.modifier.selected_value)) {
              key.modifier.selected_value.forEach(function (mod_val) {
                item.price = Number(item.price) + Number(mod_val.price)
              })
            } else {
              item.price = Number(item.price) + Number(key.modifier.selected_value.price)
            }

          }
        })
      }
      return item.price * item.quantity
    },
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
      setTimeout(() => {
        //this.close()
      }, 500)
    },
    close () {
      // destroy the vue listeners, etc
      this.$destroy()

      // remove the element from the DOM
    }
  }
}
</script>

<style lang="scss">
blockquote,
body,
dd,
dl,
dt,
fieldset,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
html,
iframe,
legend,
li,
ol,
p,
pre,
textarea,
ul {
  margin: 0;
  padding: 0;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
ul {
  list-style: none;
}
button,
input,
select {
  margin: 0;
}
html {
  box-sizing: border-box;
}
*,
::after,
::before {
  box-sizing: inherit;
}
img,
video {
  height: auto;
  max-width: 100%;
}
iframe {
  border: 0;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
td,
th {
  padding: 0;
}
.main-wrapper{
  width:100%;
  margin:0 auto;
  padding:20px;
}
.header, .receipt-section.column, .item, .grand-total {
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.logo {
  width:200px;
  height:auto;
}
.heading {
  font-size:24px;
  font-weight: bold;
}
.receipt-section {
  padding:20px 0;
  border-bottom:2px solid #000;
}
.section-head {
  margin-bottom:5px;
}
.section-head span {
  display:block;
}
.section-head span:first-child{
  font-weight: bold;
}
.section-head span:nth-child(2){
  font-size:24px;
  font-weight: bold;
}
.section-cont {
  line-height:25px;
}
.column .section-column{
  flex:50%;
  margin-bottom:20px;
}
.item {
  padding:10px;
  border-bottom:1px dashed #333;
}
.grand-total{
  padding:10px;
  font-weight: bold;
}
.item:last-child{
  border:none;
}
.extra-items {
  flex: 100%;
  display: flex;

  div {
    flex: 50%;
  }
}
.has-extra div{
  flex:50%;
  margin-bottom:5px;
}
.has-extra .item-price {
  text-align:right;
}
.item-name.extra {
  padding-left:20px;
}
.total {
  width:50%;
}
.total .item {
  border-bottom:none;
}
.total .last-item{
  border-bottom:2px solid #000;
  margin-bottom:10px;
}
.receipt-section.subtotal{
  border:none;
  display:flex;
  flex-direction: row-reverse;
}
.brand {
  text-align:center;
  font-size:12px;
  margin-top:50px;
}
</style>
